import { Button, ButtonBase, Stack, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAuthGuard } from '../../../../utils/route-guard/useAuthGuard';
import BannerIcon from '../../../../assets/images/icons/upgrade-icon.svg';

export const UpgradeBanner: FC = () => {
	const theme = useTheme();
	const { isTrial } = useAuthGuard();

	if (!isTrial) {
		return null;
	}

	return (
		<ButtonBase href={'/settings/organization/billing'} sx={{ backgroundColor: theme.palette.primary.main, m: 1, p: 2, borderRadius: 2 }}>
			<Stack direction={'row'}>
				<Stack gap={1}>
					<Typography variant={'h5'} fontWeight={700} color={(theme) => theme.palette.day['A100']}>
						<FormattedMessage id={'subscription.banner'} />
					</Typography>
					<Button
						sx={{
							width: 'fit-content',
							px: 1.5,
							py: 0.5,

							backgroundColor: theme.palette.common.black,
							color: theme.palette.common.white,
							'&:hover': { backgroundColor: theme.palette.common.black, color: theme.palette.common.white },
						}}
					>
						<FormattedMessage id={'subscription.button.upgrade'} />
					</Button>
				</Stack>
				{/* @ts-expect-error */}
				<BannerIcon width={100} height={100} />
			</Stack>
		</ButtonBase>
	);
};
